
import Vue from 'vue'

export default Vue.extend({
  name: 'MobileSidebar',
  props: {
    currentSite: {
      type: String,
      required: true,
      default: ''
    }
  },
  data () {
    return {
      isOpenSite: false
    }
  }
})
